/*
 * @Description: '关于我们'页面所有请求
 * @Author: 任录
 * @Date: 2019-07-22 15:13:52
 * @LastEditTime: 2019-07-22 17:37:49
*/

import * as http from './base'

/**
 * 提交网上预约信息
 * @param {object} data 
 */
const submitSuggestion = (data) => {
  return http.post('/os/suggestion', data)
}

const getSuggestions = (data) => {
  return http.get('/os/suggestions', data)
}


export default{ submitSuggestion,getSuggestions }


// WEBPACK FOOTER //
// ./src/http/public.js